import Vue from 'vue'
import SvgIcon from '@/components/common/SvgIcon.vue' // svg component
Vue.component('svg-icon', SvgIcon)
const svg = require.context('../svg', true, /\.svg$/)
const requireAll = (requireContext) => requireContext.keys().map(requireContext)
requireAll(svg)
